import {DetailTable} from '../../mapping-classes/detail-table';

export class Participatingaccounts implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(participatingAccounts: any) {
    if (!participatingAccounts || participatingAccounts.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = participatingAccounts.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(participatingAccounts);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen deelnemende rekeningen.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'accountNumber',
      'compensationLimit',
      'includesBalance',
      'includesCluster',
      'startDate',
      'actualBalance',
      'accountHolder',
    ];
  }

  setRowData(participatingAccounts) {
    participatingAccounts.forEach((participatingAccount) => {
      if (this.restrictedData) {
        participatingAccount.compensationLimit = this.shieldedText;
        participatingAccount.actualBalance = this.shieldedText;
      }
      this.rowData.push(participatingAccount);
    });
  }
}
